pageDetailHandler = {
    $carouselMain:  $('.carousel-main'),
    $carouselNav:   $('.carousel-nav'),
    $zoomImageContainer: $('.zoom-image-container'),
    $copyLink:      $('[href="#copy-link"]'),
    $mainImage:     $('.main-image'),
     
    init: function() {
        var self = this;

        var $carousel = this.$carouselMain.flickity({
            prevNextButtons: false,
            draggable: false,
            pageDots: false,
        });

        var $carouselNav = this.$carouselNav.flickity({
            asNavFor: ".carousel-main", 
            contain: true, 
            pageDots: false,
            prevNextButtons: false,
        });

        self.$zoomImageContainer.zoom({
            magnify: 2,
        });
        
        self.$copyLink.on('click', function(e) {
            e.preventDefault();
            navigator.clipboard.writeText(window.location.href);
            let $tooltip = $(this).find('.tooltip');
            $tooltip.addClass('active');
            setTimeout(() => {
                $tooltip.removeClass('active');
            }, 1000);
        })

        if (self.$mainImage.length > 0) {
            var src = self.$mainImage.prop('src');
            if (src.indexOf('/image-not-found.png') > -1) {
                self.$mainImage.closest('.cell-img-container').addClass('disabled')
            }
        }

        $('.carousel-main .main-image').on('focus', function() {
            $(this).closest('.carousel-cell').addClass('focused');
        }).on('blur', function() {
            $(this).closest('.carousel-cell').removeClass('focused');
        }).on('keydown', function(e) {
            if (e.key === 'Enter') {
                $(this).trigger('click')
            }
        });
        
        $('.icon-magnifier[data-open]').removeAttr('tabindex')
    }
}